declare const window: any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const dispatchMonetateQEvent = (eventName: string | null) => {
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(["trackEvent", [eventName]]);
};
